import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable card component for integrations, reporting, and case lists.
 *
 * Inputs:
 * - logo: string (URL for logo image)
 * - icon: string (icon class) or TemplateRef<any> (custom icon)
 * - title: string (main title)
 * - description: string (optional, subtitle/description)
 * - badge: string (optional, badge text)
 * - badgeClass: string (optional, badge CSS class)
 * - status: string (optional, status text)
 * - statusClass: string (optional, status CSS class)
 * - active: boolean (optional, highlight card)
 * - customContent: TemplateRef<any> (optional, for advanced custom content)
 *
 * Output:
 * - cardClick: EventEmitter<void> (emits when card is clicked)
 */
@Component({
  selector: 'app-list-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './list-card.component.html',
  styleUrl: './list-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListCardComponent {
  @Input() logo?: string;
  @Input() icon?: string | TemplateRef<any>;
  @Input() title!: string;
  @Input() description?: string;
  @Input() badge?: string;
  @Input() badgeClass?: string;
  @Input() status?: string;
  @Input() statusClass?: string;
  @Input() active: boolean = false;
  @Input() customContent?: TemplateRef<any>;

  @Output() cardClick = new EventEmitter<void>();

  onCardClick(event: Event) {
    event.stopPropagation();
    this.cardClick.emit();
  }

  isTemplateRef(value: any): boolean {
    return value instanceof TemplateRef;
  }

  getTemplateRef(value: any): TemplateRef<any> | null {
    return this.isTemplateRef(value) ? (value as TemplateRef<any>) : null;
  }
}
